import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader, Input, Button, Skeleton, EmptyState } from "@/components/ui";
import { FormModels } from "@/components/common/forms/models/form-model";
import { ModelTypesDialog } from "@/components/common/forms/models/model-types-manager";
import { ModelDataTable } from "@/components/common/data-tables/models/model-data-table";
import { useFetchModelsQuery, usePermission } from "@/hooks";

export function Models() {
  const { checkPermission } = usePermission();
  const [params, setParams] = useSearchParams();
  const [search, setSearch] = useState("");
  const perPage = Number(params.get("per_page")) || 10;
  const canView = checkPermission("models", "view models");
  const query = useFetchModelsQuery({ page: params.get("page"), per_page: perPage, search, enabled: canView });
  const page = Number(params.get("page")) || 1;
  const lastPage = query.data?.data.last_page;
  const canClampPage = query.isSuccess && !query.isPreviousData && !query.isFetching;
  useEffect(() => {
    if (!canClampPage || lastPage === undefined || page <= Math.max(1, lastPage)) return;
    setParams(previous => {
      const next = new URLSearchParams(previous);
      next.set("page", String(Math.max(1, lastPage)));
      return next;
    }, { replace: true });
  }, [canClampPage, lastPage, page, setParams]);
  function resetPage(per_page?: number) {
    setParams(previous => { const next = new URLSearchParams(previous); next.set("page", "1"); if (per_page) next.set("per_page", String(per_page)); return next; });
  }
  if (!canView) return <p role="alert">Você não tem permissão para consultar modelos de contrato.</p>;
  return <section className="space-y-6">
    <PageHeader eyebrow="Clínica · Contratos" title="Modelos de contrato" lede="Textos reutilizáveis, organizados por tipo e prontos para personalizar."
      actions={<div className="flex flex-wrap gap-2"><ModelTypesDialog /><FormModels><Button type="button" variant="petrol">Novo modelo</Button></FormModels></div>} />
    <Input type="search" className="max-w-lg" aria-label="Pesquisar modelos de contrato" placeholder="Pesquisar por nome do modelo" value={search} onChange={event => { setSearch(event.target.value); resetPage(); }} showError={false} />
    {query.isError && <div role="alert" className="space-y-3"><p>{query.data ? "Não foi possível atualizar os modelos. Os dados exibidos são da última consulta." : "Não foi possível carregar os modelos de contrato."}</p><Button variant="outline" onClick={() => void query.refetch()}>Tentar novamente</Button></div>}
    {query.data ? query.data.items.length
      ? <ModelDataTable data={query.data} perPage={perPage} handlePerPageChange={resetPage} />
      : <EmptyState title={search ? "Nenhum modelo encontrado" : "Seus contratos começam por um modelo"} description={search ? "Tente outro nome na pesquisa." : "Crie o primeiro modelo e use campos automáticos para personalizar cada contrato."} />
      : query.isLoading ? <Skeleton className="h-64 w-full" aria-label="Carregando modelos de contrato" /> : null}
  </section>;
}
